import type {
  FeatureFlagConfig,
  FeatureType,
} from '@seek/candidate-feature-flag';

// This will act as a kill switch for the GenAI chat on the homepage
export const LD_HOMEPAGE_GENAI_CHAT_FEATURE_FLAG = 'toggle-homepage-genai-chat';
const ldHomepageGenAIChatFeatureFlag = {
  key: LD_HOMEPAGE_GENAI_CHAT_FEATURE_FLAG,
  title: 'LD Homepage GenAI Chat',
  type: 'boolean',
} satisfies FeatureFlagConfig;
export type LDHomepageGenAIChatFeatureFlag = FeatureType<
  typeof ldHomepageGenAIChatFeatureFlag
>;

export const SOURCR_ON_SRP_JOB_CARD_FEATURE_FLAG =
  'toggle-sourcr-on-srp-job-card-web';
const sourcrOnSRPJobCardFeatureFlag = {
  key: SOURCR_ON_SRP_JOB_CARD_FEATURE_FLAG,
  title: 'Sourcr on SRP Job Card',
  type: 'boolean',
} satisfies FeatureFlagConfig;
export type SourcrOnSRPJobCardFeatureFlag = FeatureType<
  typeof sourcrOnSRPJobCardFeatureFlag
>;

export const HOME_FEEDBACK_LOOPS_HIDE_JOB_FEATURE_FLAG =
  'toggle-feedback-loops-hide-job';
const homeFeedbackLoopsHideJobFeatureFlag = {
  key: HOME_FEEDBACK_LOOPS_HIDE_JOB_FEATURE_FLAG,
  title: 'Feedback Loops (Hide Job)',
  type: 'boolean',
} satisfies FeatureFlagConfig;
export type HomeFeedbackLoopsHideJobFeatureFlag = FeatureType<
  typeof homeFeedbackLoopsHideJobFeatureFlag
>;

export const JDV_JOB_MODE_FEATURE_FLAG = 'feature-toggle-jdv-job-mode';
const jdvJobModeFeatureFlag = {
  key: JDV_JOB_MODE_FEATURE_FLAG,
  title: 'JDV Job Mode',
  type: 'boolean',
} satisfies FeatureFlagConfig;
export type JdvJobModeFeatureFlag = FeatureType<typeof jdvJobModeFeatureFlag>;

/**
 * All feature flags in this array will be fetched from launch darkly (via the candidate graph)
 * as chalice server-side renders
 */
export const featureFlagsToFetch: FeatureFlagConfig[] = [
  ldHomepageGenAIChatFeatureFlag,
  sourcrOnSRPJobCardFeatureFlag,
  homeFeedbackLoopsHideJobFeatureFlag,
  jdvJobModeFeatureFlag,
];
